import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ImageOverlayProps } from "../../types/interface";

const OuterImage = styled("img")({
  position: "relative",
  display: "block",
  width: "80px",
  height: "80px",
  minHeight: "80px",
  minWidth: "80px",
  objectFit: "fill",
});

const InnerImage = styled("img")({
  position: "absolute",
  top: "10px",
  left: "10px",
  zIndex: 1,
  width: "80px",
  height: "80px",
  minHeight: "80px",
  minWidth: "80px",
  objectFit: "fill",
});

/**
 *
 * Reusable component to generate Image overlay
 *
 */
export const VisonStudioImageOverlay: React.FC<ImageOverlayProps> = ({
  image1,
  image2,
}: any) => {
  return (
    <Box sx={{ position: "relative", display: "inline-block" }}>
      <OuterImage src={image1} alt="Outer" />
      <InnerImage src={image2} alt="Inner" />
    </Box>
  );
};
